module.exports = __webpack_public_path__ + "ce95b7db7afa676d1edf550d575593dd.fbx";